import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tibao-2-qxjgd",
  "use": "icon-tibao-2-qxjgd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tibao-2-qxjgd\"><defs><style></style></defs><path d=\"M513.024 344.064v-161.28L197.632 468.992 513.024 755.2V582.144c87.552 0 358.4 0 475.136 267.776v-29.696c0-119.296-116.736-501.248-475.136-476.16z\" /><path d=\"M317.44 750.08l35.328-34.304L98.816 468.992l253.952-246.784-35.328-34.304L28.16 468.992 317.44 750.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol